module.exports = __webpack_public_path__ + "img/ad3.6ec95d38.jpg";